import { render, staticRenderFns } from "./FundingSettingsSection.vue?vue&type=template&id=4fc5e489&scoped=true"
import script from "./FundingSettingsSection.vue?vue&type=script&lang=js"
export * from "./FundingSettingsSection.vue?vue&type=script&lang=js"
import style0 from "./FundingSettingsSection.vue?vue&type=style&index=0&id=4fc5e489&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc5e489",
  null
  
)

export default component.exports